import { useEffect } from "react";
import { Box } from "@chakra-ui/layout";
import NewTable from "components/NewTable";
import HeaderTable from "components/Page/HeaderTable";
import PageHeader from "components/Page/PageHeader";
import useFiltroEquipamentos from "./hook/useFiltroEquipamentos";
import useEquipamentosColumns from "./hook/useEquipamentosColumns";
import { useListarEquipamentos } from "features/equipamento/hooks/useListarEquipamentos";
import ModalCadastrarEquipamento from "./ModalCadastrarEquipamento";
import { useState } from "react";
import ModalHistoricoEquipamento from "./ModalHistoricoEquipamento";
import { VscFile } from "react-icons/vsc";
import { MdOutlineHistory } from "react-icons/md";
import { IoMdTrash } from "react-icons/io";
import useExcluirEquipamento from "features/equipamento/hooks/useExcluirEquipamento";
import { useLoading } from "components/GlobalLoading";
import ModalFiltros from "./ModalFiltros";

function ListaEquipamentos() {
  const { filtro, onChangeFiltro, onResetFiltro } = useFiltroEquipamentos();
  const [isOpenModalFiltros, setIsOpenModalFiltros] = useState(false);
  const { data, isLoading, refetch, isFetching } =
    useListarEquipamentos(filtro);
  const { mutate: excluirEquipamento, isLoading: isLoadingExcluir } =
    useExcluirEquipamento();
  const columns = useEquipamentosColumns();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [idEquipamentoHistorico, setIdEquipamentoHistorico] = useState<
    string | undefined
  >();
  const [idEquipamentoEditar, setIdEquipamentoEditar] = useState<
    string | undefined
  >();

  useEffect(() => {
    if (idEquipamentoEditar) {
      setIsOpenModal(true);
    }
  }, [idEquipamentoEditar]);

  useEffect(() => {
    if (!isOpenModal) {
      setIdEquipamentoEditar(undefined);
    }
  }, [isOpenModal]);

  useLoading(isLoadingExcluir);

  const numeroFiltroSelecionados =
    (filtro?.areaComumId ? 1 : 0) + (filtro?.local ? 1 : 0);

  return (
    <>
      <PageHeader
        title="Patrimônios"
        mb="24px"
        titleButton={"Novo patrimônio"}
        onClick={() => setIsOpenModal(true)}
        extraButtonTitle="Filtros avançados"
        extraButtonOnClick={() => setIsOpenModalFiltros(true)}
        badge={numeroFiltroSelecionados > 0}
        badgeValueExtraButton={numeroFiltroSelecionados}
      />

      <Box>
        <NewTable
          title={() => (
            <HeaderTable
              value={filtro.search || ""}
              onSearch={(v) => onChangeFiltro({ search: v })}
            />
          )}
          columns={columns}
          dataSource={data?.items || []}
          loading={isLoading || isFetching}
          customPagination={{
            currentPage: data?.meta?.currentPage ?? 1,
            totalItems: data?.meta?.totalItems ?? data?.items?.length,
            itemsPerPage: data?.meta?.itemsPerPage ?? data?.items?.length,
            onChangePage: (p, perPage) =>
              onChangeFiltro?.({ page: p, limit: perPage }),
          }}
          actions={[
            {
              title: "Editar",
              icon: () => <VscFile size={20} />,
              onClick: (v) => setIdEquipamentoEditar(v.id),
            },
            {
              title: "Excluir",
              icon: () => <IoMdTrash size={20} />,
              onClick: (v) =>
                excluirEquipamento(v.id, {
                  onSuccess: () => refetch(),
                }),
            },
            {
              title: "Histórico",
              icon: () => <MdOutlineHistory size={20} />,
              onClick: (v) => setIdEquipamentoHistorico(v.id),
            },
          ]}
        />
      </Box>
      <ModalCadastrarEquipamento
        id={idEquipamentoEditar}
        onClose={() => setIsOpenModal(false)}
        onSaved={() => {
          setIsOpenModal(false);
        }}
        visible={isOpenModal}
        refetchList={refetch}
      />

      <ModalHistoricoEquipamento
        onClose={() => setIdEquipamentoHistorico(undefined)}
        id={idEquipamentoHistorico}
        isOpenModal={!!idEquipamentoHistorico}
      />

      <ModalFiltros
        isOpen={isOpenModalFiltros}
        onClose={() => setIsOpenModalFiltros(false)}
        filtro={filtro}
        onChangeFiltro={(filtro) => {
          onChangeFiltro(filtro);
        }}
        onReset={() => {
          onResetFiltro();
        }}
      />
    </>
  );
}

export default ListaEquipamentos;
